(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lc-cartes-gratter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lc-cartes-gratter')) {
    customElements.define('lc-cartes-gratter', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.cards = [...this.querySelectorAll('.lc-cartes-gratter__card')];
        this.instruction = this.querySelector('.lc-cartes-gratter__instruction');
        this.result = this.querySelector('.lc-cartes-gratter__result');
        this.cta = this.querySelector('.lc-cartes-gratter__cta');
        this.brush = Number(this.dataset.brush) || 34;
        this.threshold = Number(this.dataset.threshold) || 45;
        this.finished = false;
        this.cards.forEach((card) => this.prepareCard(card));
        if (document.fonts) document.fonts.ready.then(() => {
          if (!this.finished) this.cards.forEach((card) => this.paintCover(card));
        });
        let resizeTimer;
        window.addEventListener('resize', () => {
          if (this.finished) return;
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => this.cards.forEach((card) => this.paintCover(card)), 200);
        });
        this.startCountdown();
      }

      prepareCard(card) {
        const canvas = document.createElement('canvas');
        canvas.setAttribute('aria-hidden', 'true');
        card.appendChild(canvas);
        const context = canvas.getContext('2d');
        const probe = document.createElement('canvas');
        probe.width = 64;
        probe.height = 64;
        const probeContext = probe.getContext('2d', { willReadFrequently: true });
        const state = { canvas, context, probeContext, dpr: 1, last: null, moves: 0 };
        card.scratchState = state;
        this.paintCover(card);

        canvas.addEventListener('pointerdown', (event) => {
          if (this.finished || this.dataset.expired === 'true') return;
          this.choose(card);
          canvas.setPointerCapture(event.pointerId);
          const rect = canvas.getBoundingClientRect();
          state.last = { x: event.clientX - rect.left, y: event.clientY - rect.top };
          context.beginPath();
          context.arc(state.last.x, state.last.y, this.brush / 2, 0, Math.PI * 2);
          context.fill();
        });
        canvas.addEventListener('pointermove', (event) => this.scratch(event, card));
        canvas.addEventListener('pointerup', () => this.stopScratch(card));
        canvas.addEventListener('pointercancel', () => this.stopScratch(card));
        card.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          if (this.finished || this.dataset.expired === 'true') return;
          this.choose(card);
          this.complete(card);
        });
      }

      choose(card) {
        if (this.activeCard && this.activeCard !== card) return;
        this.activeCard = card;
        this.dataset.state = 'active';
        card.setAttribute('aria-pressed', 'true');
        this.cards.filter((item) => item !== card).forEach((item) => item.disabled = true);
        this.instruction.textContent = this.instruction.dataset.active;
      }

      scratch(event, card) {
        const state = card.scratchState;
        if (this.finished || !state.last || this.activeCard !== card) return;
        const rect = state.canvas.getBoundingClientRect();
        const points = event.getCoalescedEvents ? event.getCoalescedEvents() : [event];
        for (let index = 0; index < points.length; index += 1) {
          const x = points[index].clientX - rect.left;
          const y = points[index].clientY - rect.top;
          state.context.beginPath();
          state.context.moveTo(state.last.x, state.last.y);
          state.context.lineTo(x, y);
          state.context.stroke();
          state.last.x = x;
          state.last.y = y;
        }
        if (++state.moves % 6 === 0) this.measure(card);
      }

      stopScratch(card) {
        const state = card.scratchState;
        state.last = null;
        this.measure(card);
      }

      paintCover(card) {
        const state = card.scratchState;
        const { canvas, context } = state;
        const rect = card.getBoundingClientRect();
        state.dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(rect.width * state.dpr);
        canvas.height = Math.round(rect.height * state.dpr);
        context.setTransform(state.dpr, 0, 0, state.dpr, 0, 0);
        const styles = getComputedStyle(this);
        const dark = styles.getPropertyValue('--lc-cartes-card').trim() || '#6b2440';
        context.globalCompositeOperation = 'source-over';
        context.fillStyle = dark;
        context.fillRect(0, 0, rect.width, rect.height);
        context.save();
        context.beginPath();
        if (context.roundRect) context.roundRect(7, 7, rect.width - 14, rect.height - 14, 6);
        else context.rect(7, 7, rect.width - 14, rect.height - 14);
        context.clip();
        context.strokeStyle = this.dataset.pattern === 'diamonds' ? 'rgba(255,255,255,.08)' : 'rgba(255,255,255,.16)';
        context.lineWidth = this.dataset.pattern === 'diamonds' ? 1.5 : 7;
        const spacing = this.dataset.pattern === 'diamonds' ? 11 : 14;
        for (let offset = -rect.height; offset < rect.width + rect.height; offset += spacing) {
          context.beginPath();
          context.moveTo(offset, 7);
          context.lineTo(offset - rect.height, rect.height - 7);
          context.stroke();
          if (this.dataset.pattern === 'diamonds') {
            context.beginPath();
            context.moveTo(offset - rect.height, 7);
            context.lineTo(offset, rect.height - 7);
            context.stroke();
          }
        }
        context.restore();
        context.strokeStyle = 'rgba(255,255,255,.5)';
        context.lineWidth = 1.5;
        if (context.roundRect) {
          context.beginPath();
          context.roundRect(7, 7, rect.width - 14, rect.height - 14, 6);
          context.stroke();
        } else context.strokeRect(7, 7, rect.width - 14, rect.height - 14);
        context.fillStyle = '#fff';
        context.font = `700 11px ${styles.fontFamily}`;
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        const number = String(this.cards.indexOf(card) + 1);
        context.fillText(number, rect.width - 14, 17);
        context.save();
        context.translate(14, rect.height - 17);
        context.rotate(Math.PI);
        context.fillText(number, 0, 0);
        context.restore();
        context.fillStyle = styles.getPropertyValue('--lc-cartes-gold-light').trim() || '#efe0c6';
        context.beginPath();
        context.arc(rect.width / 2, rect.height / 2, 16, 0, Math.PI * 2);
        context.fill();
        context.fillStyle = dark;
        context.font = `600 15px ${styles.fontFamily}`;
        context.fillText('L', rect.width / 2, rect.height / 2);
        context.globalCompositeOperation = 'destination-out';
        context.lineWidth = this.brush;
        context.lineCap = 'round';
        context.lineJoin = 'round';
      }

      measure(card) {
        if (this.finished || this.activeCard !== card) return;
        const { canvas, probeContext } = card.scratchState;
        probeContext.clearRect(0, 0, 64, 64);
        probeContext.drawImage(canvas, 0, 0, 64, 64);
        const pixels = probeContext.getImageData(0, 0, 64, 64).data;
        let transparent = 0;
        for (let index = 3; index < pixels.length; index += 4) {
          if (pixels[index] === 0) transparent += 1;
        }
        if (transparent / 4096 * 100 > this.threshold) this.complete(card);
      }

      complete(card) {
        if (this.finished) return;
        this.finished = true;
        this.dataset.state = 'won';
        card.scratchState.canvas.dataset.done = 'true';
        this.cards.forEach((item) => item.disabled = true);
        this.instruction.hidden = true;
        this.result.hidden = false;
        this.cta.hidden = false;
        this.confetti(card);
        this.cta.focus({ preventScroll: true });
      }

      confetti(card) {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const styles = getComputedStyle(this);
        const colors = [
          styles.getPropertyValue('--lc-cartes-gold-light').trim(),
          styles.getPropertyValue('--lc-cartes-gold').trim(),
          styles.getPropertyValue('--lc-cartes-accent').trim(),
        ];
        const canvas = document.createElement('canvas');
        canvas.className = 'lc-cartes-gratter__confetti';
        card.appendChild(canvas);
        const context = canvas.getContext('2d');
        const bounds = canvas.getBoundingClientRect();
        const ratio = card.scratchState.dpr;
        canvas.width = bounds.width * ratio;
        canvas.height = bounds.height * ratio;
        context.scale(ratio, ratio);
        const pieces = [];
        for (let index = 0; index < 70; index += 1) {
          pieces.push({
            x: bounds.width / 2,
            y: bounds.height / 2,
            vx: (Math.random() - 0.5) * 13,
            vy: Math.random() * -11 - 3,
            width: 5 + Math.random() * 5,
            height: 8 + Math.random() * 6,
            angle: Math.random() * Math.PI,
            velocityAngle: (Math.random() - 0.5) * 0.3,
            color: colors[index % colors.length],
          });
        }
        let start = null;
        const loop = (time) => {
          if (!start) start = time;
          const age = time - start;
          context.clearRect(0, 0, bounds.width, bounds.height);
          for (const piece of pieces) {
            piece.vy += 0.42;
            piece.x += piece.vx;
            piece.y += piece.vy;
            piece.angle += piece.velocityAngle;
            context.save();
            context.globalAlpha = Math.max(0, 1 - age / 1600);
            context.translate(piece.x, piece.y);
            context.rotate(piece.angle);
            context.fillStyle = piece.color;
            context.fillRect(-piece.width / 2, -piece.height / 2, piece.width, piece.height);
            context.restore();
          }
          if (age < 1600) requestAnimationFrame(loop);
          else canvas.remove();
        };
        requestAnimationFrame(loop);
      }

      startCountdown() {
        const timer = this.querySelector('.lc-cartes-gratter__countdown b');
        const duration = Math.max(1, Number(this.dataset.minutes) || 10) * 60000;
        const key = 'lc-cartes-gratter-deadline';
        let deadline = 0;
        try { deadline = Number(sessionStorage.getItem(key)); } catch (error) {}
        // Comme lc-scratch : une deadline expiree en sessionStorage doit
        // repartir, sinon le jeu reste bloque tant que l onglet vit.
        if (!deadline || deadline < Date.now()) {
          deadline = Date.now() + duration;
          try { sessionStorage.setItem(key, String(deadline)); } catch (error) {}
        }
        const update = () => {
          const remaining = Math.max(0, deadline - Date.now());
          const minutes = Math.floor(remaining / 60000);
          const seconds = Math.floor(remaining / 1000) % 60;
          timer.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
          if (remaining === 0) {
            clearInterval(this.clock);
            this.instruction.hidden = false;
            this.instruction.textContent = this.dataset.expiredLabel;
            this.result.hidden = true;
            this.cta.hidden = true;
          }
        };
        this.clock = setInterval(update, 1000);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-cuvette-roulette"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lc-cuvette-roulette')) {
    customElements.define('lc-cuvette-roulette', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.game = this.querySelector('.lc-cuvette-roulette__game');
        this.action = this.querySelector('.lc-cuvette-roulette__action');
        this.jackpot = this.querySelector('.lc-cuvette-roulette__jackpot');
        this.instruction = this.querySelector('.lc-cuvette-roulette__instruction');
        this.result = this.querySelector('.lc-cuvette-roulette__result');
        this.cta = this.querySelector('.lc-cuvette-roulette__cta');
        this.play_btn = this.querySelector('.lc-cuvette-roulette__play');
        if (this.play_btn) this.play_btn.addEventListener('click', () => this.play());
        this.game.addEventListener('click', () => this.play());
        this.game.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          this.play();
        });
        this.startCountdown();
      }
      play() {
        if (this.dataset.state !== 'idle' || this.dataset.expired === 'true') return;
        if (this.play_btn) this.play_btn.hidden = true;
        this.dataset.state = 'spinning';
        this.game.disabled = true;
        this.action.textContent = this.dataset.spinningLabel;
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        setTimeout(() => this.resolve(), reduce ? 0 : Number(this.dataset.spinMs) || 6000);
      }
      resolve() {
        if (this.dataset.expired === 'true') return;
        this.dataset.state = 'won';
        this.instruction.hidden = true;
        this.action.hidden = true;
        this.jackpot.hidden = false;
        this.result.hidden = false;
        this.cta.hidden = false;
        this.cta.focus({ preventScroll: true });
      }
      startCountdown() {
        const timer = this.querySelector('.lc-cuvette-roulette__countdown b');
        const duration = Math.max(1, Number(this.dataset.minutes) || 10) * 60000;
        const key = 'lc-cuvette-roulette-deadline';
        let deadline = 0;
        try { deadline = Number(sessionStorage.getItem(key)); } catch (error) {}
        // Comme lc-scratch : une deadline expiree en sessionStorage doit
        // repartir, sinon le jeu reste bloque tant que l onglet vit.
        if (!deadline || deadline < Date.now()) {
          deadline = Date.now() + duration;
          try { sessionStorage.setItem(key, String(deadline)); } catch (error) {}
        }
        const update = () => {
          const remaining = Math.max(0, deadline - Date.now());
          const minutes = Math.floor(remaining / 60000);
          const seconds = Math.floor(remaining / 1000) % 60;
          timer.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
          if (remaining === 0) {
            clearInterval(this.clock);
            this.instruction.hidden = false;
            this.instruction.textContent = this.dataset.expiredLabel;
            this.action.hidden = true;
            this.jackpot.hidden = true;
            this.result.hidden = true;
            this.cta.hidden = true;
          }
        };
        this.clock = setInterval(update, 1000);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-machine-sous"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lc-machine-sous')) {
    customElements.define('lc-machine-sous', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.game = this.querySelector('.lc-machine-sous__game');
        this.instruction = this.querySelector('.lc-machine-sous__instruction');
        this.result = this.querySelector('.lc-machine-sous__result');
        this.cta = this.querySelector('.lc-machine-sous__cta');
        this.play_btn = this.querySelector('.lc-machine-sous__play');
        if (this.play_btn) this.play_btn.addEventListener('click', () => this.play());
        this.game.addEventListener('click', () => this.play());
        this.game.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          this.play();
        });
        this.startCountdown();
      }

      play() {
        if (this.dataset.state !== 'idle' || this.dataset.expired === 'true') return;
        if (this.play_btn) this.play_btn.hidden = true;
        this.dataset.state = 'spinning';
        this.game.disabled = true;
        this.instruction.textContent = this.dataset.spinningLabel;
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        setTimeout(() => this.resolve(), reduce ? 0 : (Number(this.dataset.spinMs) || 3000) + 700);
      }

      resolve() {
        if (this.dataset.expired === 'true') return;
        this.dataset.state = 'won';
        this.instruction.hidden = true;
        this.result.hidden = false;
        this.cta.hidden = false;
        this.cta.focus({ preventScroll: true });
      }

      startCountdown() {
        const timer = this.querySelector('.lc-machine-sous__countdown b');
        const duration = Math.max(1, Number(this.dataset.minutes) || 10) * 60000;
        const key = 'lc-machine-sous-deadline';
        let deadline = 0;
        try { deadline = Number(sessionStorage.getItem(key)); } catch (error) {}
        // Comme lc-scratch : une deadline expiree en sessionStorage doit
        // repartir, sinon le jeu reste bloque tant que l onglet vit.
        if (!deadline || deadline < Date.now()) {
          deadline = Date.now() + duration;
          try { sessionStorage.setItem(key, String(deadline)); } catch (error) {}
        }
        const update = () => {
          const remaining = Math.max(0, deadline - Date.now());
          const minutes = Math.floor(remaining / 60000);
          const seconds = Math.floor(remaining / 1000) % 60;
          timer.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
          if (remaining === 0) {
            clearInterval(this.clock);
            this.instruction.hidden = false;
            this.instruction.textContent = this.dataset.expiredLabel;
            this.result.hidden = true;
            this.cta.hidden = true;
          }
        };
        this.clock = setInterval(update, 1000);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-roue-roulette"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lc-roue-roulette')) {
    customElements.define('lc-roue-roulette', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.game = this.querySelector('.lc-roue-roulette__game');
        this.action = this.querySelector('.lc-roue-roulette__action');
        this.instruction = this.querySelector('.lc-roue-roulette__instruction');
        this.result = this.querySelector('.lc-roue-roulette__result');
        this.cta = this.querySelector('.lc-roue-roulette__cta');
        this.play_btn = this.querySelector('.lc-roue-roulette__play');
        if (this.play_btn) this.play_btn.addEventListener('click', () => this.play());
        this.game.addEventListener('click', () => this.play());
        this.game.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          this.play();
        });
        this.startCountdown();
      }
      play() {
        if (this.dataset.state !== 'idle' || this.dataset.expired === 'true') return;
        if (this.play_btn) this.play_btn.hidden = true;
        this.dataset.state = 'spinning';
        this.game.disabled = true;
        this.action.textContent = this.dataset.spinningLabel;
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        setTimeout(() => this.resolve(), reduce ? 0 : Number(this.dataset.spinMs) || 4000);
      }
      resolve() {
        if (this.dataset.expired === 'true') return;
        this.dataset.state = 'won';
        this.instruction.hidden = true;
        this.result.hidden = false;
        this.cta.hidden = false;
        this.cta.focus({ preventScroll: true });
      }
      startCountdown() {
        const timer = this.querySelector('.lc-roue-roulette__countdown b');
        const duration = Math.max(1, Number(this.dataset.minutes) || 10) * 60000;
        const key = 'lc-roue-roulette-deadline';
        let deadline = 0;
        try { deadline = Number(sessionStorage.getItem(key)); } catch (error) {}
        // Comme lc-scratch : une deadline expiree en sessionStorage doit
        // repartir, sinon le jeu reste bloque tant que l onglet vit.
        if (!deadline || deadline < Date.now()) {
          deadline = Date.now() + duration;
          try { sessionStorage.setItem(key, String(deadline)); } catch (error) {}
        }
        const update = () => {
          const remaining = Math.max(0, deadline - Date.now());
          const minutes = Math.floor(remaining / 60000);
          const seconds = Math.floor(remaining / 1000) % 60;
          timer.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
          if (remaining === 0) {
            clearInterval(this.clock);
            this.instruction.hidden = false;
            this.instruction.textContent = this.dataset.expiredLabel;
            this.result.hidden = true;
            this.cta.hidden = true;
          }
        };
        this.clock = setInterval(update, 1000);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
